//todo: добавить типизацию для возвращаемых значений
import { HttpsCallableResult } from 'firebase/functions';

export abstract class AbstractSocialService {

    readonly APP_ID: number | string;
    readonly GROUP_ID: number | string;
    readonly GAME_LINK: string;

    abstract addToFavorite(): Promise<any>; //только ВК ?

    abstract getAllowNotification(): Promise<any>; //только ВК ?

    abstract showInviteOneUser(uid: number): Promise<void>; //только ВК ?

    abstract showNotification(): Promise<any>; //только OK ?

    abstract getFriends(): Promise<any>;

    abstract initApp(): Promise<any>;

    abstract joinGroup(): Promise<any>;

    abstract postMessage(message: string, attachments: string): Promise<any>;

    abstract showInvite(): Promise<any>;

    abstract getToken(): Promise<HttpsCallableResult<string>> ; //todo: rework class dependency and design
}